module.exports = __webpack_public_path__ + "img/letter-p.d87f6e01.png";